
<template>
    <div>
<h3>{{opcion}}</h3> 

    <v-card>
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Registro de Opcions</v-toolbar-title>
      </v-toolbar>
      <v-tabs v-model="tab">
       
       <v-tab href="#one">
          <v-icon left>mdi-account</v-icon>
          Registro
        </v-tab>
        
        <v-tab href="#two" >
          <v-icon left>mdi-dns</v-icon>
          Listado
        </v-tab>
    </v-tabs>
         <v-tabs-items :value="tab"> 
          <!-- <div :value="tab"> -->
        <v-tab-item value="one">
          <v-card flat>
            <v-card-text>
               <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
   
   
    <v-text-field
           v-model="opcion.descripcion"
           label="Descripcion"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>
   
   
    <v-text-field
           v-model="opcion.link"
           label="Link"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>
   
   
    <v-text-field
           v-model="opcion.linkPhoto"
           label="LinkPhoto"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>
   
   
    <v-text-field
           v-model="opcion.tipo"
           label="Tipo"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>
   
   
    <v-text-field
           v-model="opcion.observacion"
           label="Observacion"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>
   
   
    <v-text-field
           v-model="opcion.linkVideo"
           label="LinkVideo"
           :counter="3"
           :rules="textRules"
           required
         ></v-text-field>
   
   
   

 <v-row no-gutters>
      
      <v-col>
      </v-col>

      <v-col order="last">
        
      </v-col>
     
    </v-row>


      
      <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="registrar"
      >
        Registrar
      </v-btn>

      <v-btn
        color="error"
        class="mr-4"
        @click="reset();"
      >
        Cancelar
      </v-btn>
  
    </v-form> 
            </v-card-text>


           <v-card-text>

            <v-alert
      border="top"
      colored-border
      type="info"
      elevation="2"
      
    >
      El presente registro es responsable de almacenar información sobre el Opcion.<br>
      
    </v-alert>

          </v-card-text>




          </v-card>
        </v-tab-item>

   <!--  fin item 1-->
<v-tab-item value="two">
          <v-card flat>
            <v-card-text>

<v-text-field
            v-model="buscador" 
            placeholder="Ejemplo: Juan Perez"
            outlined
           
          >
          <template v-slot:label>
          <v-icon style="vertical-align: middle">
            mdi-magnify
          </v-icon>
          Busqueda por nombre de Opcion
        </template>
          
          
          </v-text-field>



             
 <v-simple-table fixed-header>
    <template v-slot:default>


      <thead class="thead-dark">
        <tr>    
			
		<th scope="col">Id</th>
		<th scope="col">Descripcion</th>
		<th scope="col">Link</th>
		<th scope="col">LinkPhoto</th>
		<th scope="col">Tipo</th>
		<th scope="col">Observacion</th>
		<th scope="col">LinkVideo</th>
		        <th scope="col">Editar</th>
		          <th scope="col">Eliminar</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="opcion in opcionsBuscados" :key="opcion.codigo">       
<td>{{opcion.id}}</td>


<td>{{opcion.descripcion}}</td>


<td>{{opcion.link}}</td>


<td>{{opcion.linkPhoto}}</td>


<td>{{opcion.tipo}}</td>


<td>{{opcion.observacion}}</td>


<td>{{opcion.linkVideo}}</td>


<td>
              <opcion-dialog :opcionData="opcion"   @opcionEdit="recibirOpcion"></opcion-dialog>
              
            </td>
            <td>
              <button @click="eliminarOpcion(opcion)" class="btn"><v-icon left>mdi-delete-forever</v-icon></button>
            </td>
     
 </tr>
      </tbody>
    </template>
  </v-simple-table>

            </v-card-text>
          </v-card>
        </v-tab-item>

        <!--  fin item 2-->
     

      </v-tabs-items> 

          <!-- </div> -->
    </v-card>
  </div>
</template>


<script>
import opcionService from "@/services/opcionService.js";

import axios from 'axios'

import OpcionDialog from '../opcion/OpcionDialog';


export default {
     name: 'Opcion',
    
  components: {
   OpcionDialog
  },
  computed: {
    tab: {
      set (tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } })
      },
      get () {
        return this.$route.query.tab
      }
    }
  },
    data: vm => ({
    valid: true,
    tab:"",
    buscador:'',
showPass: false,
  opcions: [],
        opcion:{
id:'',
descripcion:'',
link:'',
linkPhoto:'',
tipo:'',
color:'',
observacion:'',
linkVideo:'',  
        },









        rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres',
                  emailMatch: () => (`The email and password you entered don't match`),
                },
        	messages:undefined,
        
        
        
         textRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 3) || "Debe contener al menos 3 caracteres",
            ],
        
        
        
        
        
        
    
  }),
  created(){

       }
  ,mounted(){
      this.listarOpcions();
    
      this.tab="two";

   
    },

  methods: {
    listarOpcions() {
      opcionService
        .listarOpcions()
        .then((resposta) => {
      //    console.log(resposta.data);
          this.opcions = resposta.data;
        })
  
  },
    registrar(){
    if (this.$refs.form.validate()) {
   
          if(this.opcion.codigo===""||this.opcion.codigo===null){
      //Eliminar para que funcione el auto incrementable
        delete this.opcion.codigo;
          }

        console.log(this.opcion);

          opcionService.save(this.opcion,this.config).then(resposta=>{
           this.limpiar();
              alert('Guardado exitoso!!')
              this.listarOpcions();
               this.selectedTab="second";
          });


        
      }
    },
    editarOpcion(opcion){

    //  console.log('Editar Opcion');
      
     //
     // console.log(this.opcion);


     this.opcion.id=opcion.id;
     this.opcion.id=opcion.id;
     this.opcion.descripcion=opcion.descripcion;
     this.opcion.link=opcion.link;
     this.opcion.linkPhoto=opcion.linkPhoto;
     this.opcion.tipo=opcion.tipo;
     this.opcion.observacion=opcion.observacion;
     this.opcion.linkVideo=opcion.linkVideo;
     

      this.tab="one";
  
       console.log(opcion);

    },
    eliminarOpcion(opcion){

        if(confirm('Desea remover al opcion')){
        
        opcionService.delete(opcion).then(resposta=>{
          this.listarOpcions();
          this.errors=[]
          this.limpiar();

        }).catch(e=>{

          this.errors =e.response.data.errors

        })

        }


        


    },
    limpiar(){

     
		this.opcion={
				id:'',
				id:0,
				descripcion:'',
				link:'',
				linkPhoto:'',
				tipo:'',
				observacion:'',
				linkVideo:'',
	}

        
    },
		
    validate () {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
    //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
  recibirOpcion:function(opcion){

      console.log('En elemento padre Opcion despues de editar');
        console.log(opcion);
 
    },
  },

    watch: {
      date (val) {
        
		
       
      },
    },
  computed:{
    


    	
    opcionsBuscados() {
          return this.opcions.filter(opcion => {
            return opcion.descripcion.toLowerCase().includes(this.buscador.toLowerCase());
          });
    
      }
    
  
  },
};
</script>




